import React, {
  useEffect,
  useState,
} from "react";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  signOut,
} from "firebase/auth";

import {
  auth,
} from "../firebase";

import "./Logout.css";


export default function Logout() {

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [loggedOut, setLoggedOut] = useState(false);
  const [error, setError] = useState("");


  /* =====================================================
     PREVIOUS PAGE
  ===================================================== */

  const previousPage =
    location.state?.from ||
    "/dashboard";


  /* =====================================================
     CLEAR EVERYTHING FROM USER STORAGE
  ===================================================== */

  const clearUserSession = () => {

    /*
     * Hifadhi lugha ya Login kabla
     * ya kufuta localStorage.
     *
     * Login yako inatumia:
     *
     * localStorage.getItem("loginLanguage")
     */

    let savedLanguage = null;

    try {

      savedLanguage =
        localStorage.getItem(
          "loginLanguage"
        );

    } catch (error) {

      console.error(
        "Unable to read loginLanguage:",
        error
      );

    }


    /* =================================================
       FUTA KILA KITU KWENYE LOCAL STORAGE
    ================================================= */

    try {

      localStorage.clear();

    } catch (error) {

      console.error(
        "localStorage.clear() failed:",
        error
      );

    }


    /* =================================================
       HAKIKISHA KEYS ZILIZOJULIKANA ZIMEFUTWA
    ================================================= */

    const keysToRemove = [
      "user",
      "username",
      "userId",
      "email",
      "authenticated",
      "role",
      "token",
      "accessToken",
      "authToken",
      "uid",
      "balance",
      "tshBalance",
      "usdtBalance",
      "loginUser",
      "currentUser",
      "session",
    ];


    keysToRemove.forEach((key) => {

      try {

        localStorage.removeItem(key);

      } catch (error) {

        console.error(
          `Unable to remove localStorage key: ${key}`,
          error
        );

      }

    });


    /* =================================================
       RUDISHA LOGIN LANGUAGE
    ================================================= */

    if (savedLanguage) {

      try {

        localStorage.setItem(
          "loginLanguage",
          savedLanguage
        );

      } catch (error) {

        console.error(
          "Unable to restore loginLanguage:",
          error
        );

      }

    }


    /* =================================================
       FUTA SESSION STORAGE YOTE
    ================================================= */

    try {

      sessionStorage.clear();

    } catch (error) {

      console.error(
        "sessionStorage.clear() failed:",
        error
      );

    }


    /* =================================================
       HAKIKISHA SESSION KEYS ZILIZOJULIKANA ZIMEFUTWA
    ================================================= */

    const sessionKeysToRemove = [
      "user",
      "username",
      "userId",
      "email",
      "authenticated",
      "role",
      "token",
      "accessToken",
      "authToken",
      "uid",
      "balance",
      "tshBalance",
      "usdtBalance",
      "session",
    ];


    sessionKeysToRemove.forEach((key) => {

      try {

        sessionStorage.removeItem(key);

      } catch (error) {

        console.error(
          `Unable to remove sessionStorage key: ${key}`,
          error
        );

      }

    });

  };


  /* =====================================================
     FIREBASE LOGOUT
  ===================================================== */

  const performLogout = async () => {

    setLoading(true);
    setError("");


    try {

      /* ===============================================
         FIREBASE SIGN OUT
      =============================================== */

      if (auth) {

        await signOut(auth);

      }


      /* ===============================================
         CLEAR LOCAL SESSION
      =============================================== */

      clearUserSession();


      /* ===============================================
         SUCCESS
      =============================================== */

      setLoggedOut(true);

    } catch (err) {

      console.error(
        "Logout error:",
        err
      );


      /*
       * Hata ya Firebase iwepo,
       * bado tunafuta local/session storage.
       */

      try {

        clearUserSession();

        setLoggedOut(true);

      } catch (clearError) {

        console.error(
          "Storage clear error:",
          clearError
        );

        setError(
          "Logout failed. Please try again."
        );

      }

    } finally {

      setLoading(false);

    }

  };


  /* =====================================================
     AUTO LOGOUT
  ===================================================== */

  useEffect(() => {

    performLogout();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  /* =====================================================
     BACK IN
  ===================================================== */

  const handleBackIn = () => {

    /*
     * User amerudi kwenye page iliyopita.
     *
     * Kama route hiyo inalindwa,
     * authentication guard itamrudisha Login.
     */

    navigate(
      previousPage,
      {
        replace: true,
      }
    );

  };


  /* =====================================================
     BACK OUT
  ===================================================== */

  const handleBackOut = () => {

    /*
     * Futa storage tena kabla ya Login.
     */

    clearUserSession();


    navigate(
      "/login",
      {
        replace: true,
      }
    );

  };


  /* =====================================================
     LOGIN AGAIN
  ===================================================== */

  const handleLogin = () => {

    navigate(
      "/login",
      {
        replace: true,
      }
    );

  };


  /* =====================================================
     RETRY LOGOUT
  ===================================================== */

  const handleRetry = () => {

    performLogout();

  };


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="logout-page">

      {/* =================================================
          BACKGROUND
      ================================================= */}

      <div className="logout-bg-grid"></div>

      <div
        className="
          logout-bg-glow
          logout-glow-one
        "
      ></div>

      <div
        className="
          logout-bg-glow
          logout-glow-two
        "
      ></div>


      {/* =================================================
          MAIN CARD
      ================================================= */}

      <main className="logout-card">


        {/* =================================================
            LOGO
        ================================================= */}

        <div className="logout-logo-wrapper">

          <div className="logout-logo">

            <span
              className="
                logout-logo-bar
                bar-one
              "
            ></span>

            <span
              className="
                logout-logo-bar
                bar-two
              "
            ></span>

            <span
              className="
                logout-logo-bar
                bar-three
              "
            ></span>

          </div>

        </div>


        {/* =================================================
            LOADING
        ================================================= */}

        {loading && (

          <div className="logout-content">

            <div className="logout-spinner"></div>

            <h1>
              Signing out
            </h1>

            <p>
              Please wait while we securely
              close your session.
            </p>

          </div>

        )}


        {/* =================================================
            SUCCESS
        ================================================= */}

        {!loading && loggedOut && (

          <div className="logout-content">


            {/* =============================================
                SUCCESS ICON
            ============================================= */}

            <div className="logout-success-icon">

              <span>
                ✓
              </span>

            </div>


            {/* =============================================
                STATUS
            ============================================= */}

            <div className="logout-status">
              SESSION CLOSED
            </div>


            {/* =============================================
                TITLE
            ============================================= */}

            <h1>
              Logged Out
            </h1>


            {/* =============================================
                DESCRIPTION
            ============================================= */}

            <p>
              Your account session has been
              securely closed.
            </p>


            {/* =============================================
                ACTION BUTTONS
            ============================================= */}

            <div className="logout-actions">


              {/* ===========================================
                  BACK IN
              =========================================== */}

              <button
                type="button"
                className="logout-back-in"
                onClick={handleBackIn}
              >

                <span className="logout-button-icon">
                  ←
                </span>

                <span>
                  Back In
                </span>

              </button>


              {/* ===========================================
                  BACK OUT
              =========================================== */}

              <button
                type="button"
                className="logout-back-out"
                onClick={handleBackOut}
              >

                <span>
                  Back Out
                </span>

                <span className="logout-button-icon">
                  →
                </span>

              </button>

            </div>


            {/* =============================================
                LOGIN AGAIN
            ============================================= */}

            <button
              type="button"
              className="logout-login-button"
              onClick={handleLogin}
            >
              Login Again
            </button>


            {/* =============================================
                SECURITY STATUS
            ============================================= */}

            <div className="logout-security">

              <span className="logout-security-dot"></span>

              <span>
                Secure session terminated
              </span>

            </div>

          </div>

        )}


        {/* =================================================
            ERROR
        ================================================= */}

        {!loading && error && (

          <div className="logout-content">


            <div className="logout-error-icon">
              !
            </div>


            <div
              className="
                logout-status
                logout-status-error
              "
            >
              LOGOUT ERROR
            </div>


            <h1>
              Something went wrong
            </h1>


            <p>
              {error}
            </p>


            <div className="logout-actions">


              <button
                type="button"
                className="logout-back-out"
                onClick={handleRetry}
              >
                Try Again
              </button>


              <button
                type="button"
                className="logout-login-button"
                onClick={handleBackOut}
              >
                Go to Login
              </button>

            </div>

          </div>

        )}

      </main>


      {/* =================================================
          FOOTER
      ================================================= */}

      <footer className="logout-footer">

        <span>
          SECURE
        </span>

        <i>
          •
        </i>

        <span>
          FAST
        </span>

        <i>
          •
        </i>

        <span>
          RELIABLE
        </span>

      </footer>

    </div>

  );

}